<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>
                    Liste des mails brouillons
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="brouillons"
                        :search="search"
                        :loading="brouillons===undefined" loading-text="Chargement en cours..."
                        sort-by="label"
                        class="elevation-1">
                    <template v-slot:item._user_id="{item}">
                        <div v-if="item._type==='marchands'">
                            Tous les marchands
                        </div>
                        <div v-else-if="item._type==='utilisateurs'">
                            Tous les utilisateurs
                        </div>
                        <div v-else-if="item._type==='abonnes'">
                            Tous les abonnés
                        </div>
                        <div v-else>
                            <v-row>
                                <v-chip @click="userdetail(item._user)"
                                        class="ma-1">
                                    {{item._user.length}}
                                </v-chip>

                            </v-row>

                        </div>
                    </template>
                    <template v-slot:item._created_at="{item}">
                        {{ new Date(item._created_at).toLocaleDateString()}}
                    </template>
                    <template v-slot:top>
                        <v-dialog v-model="dialog2" max-width="700px">
                            <v-card>
                                <v-card-title>
                                    <span style="font-weight: bold">Les utilisateurs</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-fade-transition mode="out-in"  >
                                        <v-row>

                                            <v-col cols="12">
                                                <v-card>
                                                    <div v-for="usersi in userdetails" :key="usersi">
                                                        <v-row >
                                                            <v-col cols="4" sm="4" md="4" >
                                                                <v-chip
                                                                        class="ma-1">
                                                                    {{usersi._first_name}} {{usersi._last_name}}
                                                                </v-chip>
                                                            </v-col>
                                                        </v-row>
                                                    </div>
                                                </v-card>
                                            </v-col>

                                        </v-row>
                                    </v-fade-transition>

                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click.prevent="close2">{{$t('close')}}</v-btn>

                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialog1" max-width="700px">
                            <v-card>
                                <v-card-title>
                                    <span style="font-weight: bold">DETAIL DU MAIL</span>
                                </v-card-title>

                                <v-card-text>
                                    <v-fade-transition mode="out-in"  >
                                        <v-row>

                                            <v-col cols="12">
                                                <v-card>
                                                    <span style="font-weight: bold"> Subjet</span>
                                                    <v-card>
                                                        {{desc._subjet}}
                                                    </v-card>
                                                </v-card>
                                            </v-col>

                                        </v-row>
                                    </v-fade-transition>
                                    <v-card>
                                        <span style="font-weight: bold"> Contenu</span>
                                        <p v-html="desc._message"></p>
                                    </v-card>
                                    <v-fade-transition mode="out-in"  v-if="desc._piece">
                                        <v-row>

                                            <v-col cols="12">
                                                <span style="font-weight: bold"> Pièce Joint</span>
                                                <v-card>
                                                    <a :href="'/'+desc._piece" target="_blank">{{getFileOriginalName(desc._piece)}}</a>
                                                </v-card>
                                            </v-col>

                                        </v-row>
                                    </v-fade-transition>
                                    <v-row>

                                        <v-col cols="12">
                                            <v-card>
                                                <span style="font-weight: bold"> Date d'envoie</span>
                                                <v-card>
                                                    {{ new Date(desc._created_at).toLocaleDateString()}}
                                                </v-card>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-card>
                                                <span style="font-weight: bold"> Envoyé à</span>
                                                <div v-if="desc._type==='marchands'">
                                                    Tous les marchands
                                                </div>
                                                <div v-else-if="desc._type==='utilisateurs'">
                                                    Tous les utilisateurs
                                                </div>
                                                <div v-else-if="desc._type==='abonnes'">
                                                    Tous les abonnés
                                                </div>
                                                <div v-else>
                                                    <div v-for="usersi in desc._user" :key="usersi">
                                                        <v-row >
                                                            <v-col cols="4" sm="4" md="4" >
                                                                <v-chip
                                                                        class="ma-1">
                                                                    {{usersi._first_name}} {{usersi._last_name}}
                                                                </v-chip>
                                                            </v-col>
                                                        </v-row>
                                                    </div>
                                                </div>

                                            </v-card>
                                        </v-col>

                                    </v-row>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click.prevent="close1">{{$t('close')}}</v-btn>

                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <v-toolbar flat color="white">
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <router-link  class="offset-11 mb-2 float-right" :to="{name:'newsletters'}">
                                        <v-btn  color="default" dark >{{$t('add')}}</v-btn>
                                    </router-link>
                                </v-col>
                            </v-row>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <div style="text-align:  right">
                            <v-menu
                                    key="text"
                                    rounded="b-xl">
                                <template v-slot:activator="{ attrs, on }">

                                    <v-icon

                                            class="black--text "
                                            v-bind="attrs"
                                            v-on="on">mdi-dots-vertical</v-icon>

                                </template>
                                <v-list>
                                    <v-list-item  @click="showdescription(item)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6"> mdi-eye
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>

                                            <v-list-item-title >
                                                Détails
                                            </v-list-item-title>
                                        </v-list-item-content>

                                    </v-list-item>
                                    <!--     <v-list-item  v-if="item._cat==='brouillon'"  @click="editItem(item)">
                                             <v-list-item-icon>
                                                 <v-icon color="#29B3A6"> mdi-pencil
                                                 </v-icon>
                                             </v-list-item-icon>
                                             <v-list-item-content>

                                                 <v-list-item-title >
                                                     <router-link :to="'/newsletters/'+item._id">Modifier</router-link>
                                                 </v-list-item-title>
                                             </v-list-item-content>

                                         </v-list-item>-->
                                    <v-list-item v-if="item._cat==='envoyer'"  @click="corbeille(item)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">  mdi-delete
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>

                                            <v-list-item-title>
                                                Mettre dans corbeille

                                            </v-list-item-title>
                                        </v-list-item-content>

                                    </v-list-item>
                                    <v-list-item v-if="item._cat==='brouillon'"  @click="deleteItem(item)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">  mdi-delete
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>

                                            <v-list-item-title>
                                                Supprimer
                                            </v-list-item-title>
                                        </v-list-item-content>

                                    </v-list-item>
                                    <v-list-item v-if="item._cat==='corbeille'"  @click="restitue(item)">
                                        <v-list-item-icon>
                                            <v-icon color="#29B3A6">  mdi-replay
                                            </v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>

                                            <v-list-item-title>
                                                Restitué
                                            </v-list-item-title>
                                        </v-list-item-content>

                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>

                    </template>0
                    <template v-slot:no-data>
                        {{$t('no_data')}}
                    </template>
                </v-data-table>
            </v-card>

        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from "../../../../mixins/helpers";
    export default {
        name: "Brouillon",
        mixins:[helpers(this)],
        data () {
            return {
                submitting:false,
                valid:true,
                lazy:false,
                mis:false,
                tabs: null,
                search_key:'',
                errors:{},
                userdetails:{},
                brouillons:[],
                customSnack:{
                    snackbar: false,
                    text: "",
                    snackcolor:"black",
                    snackbBtnColor:"white",
                    snacktimeout:2000
                },
                search: '',
                desc:"",
                dialog1: false,
                dialog2: false,
                dialog: '',
                id:undefined,
                headers: [
                    {text: 'Utilisateurs', value: '_user_id'},
                    {text: 'Sujet', value: '_subjet'},
                    {text: this.$t('date'), value: '_created_at'},
                    { text: '', value: 'actions', sortable: false },

                ],
                editedIndex: -1,
                editedItem: {
                    _description: '',
                    _code: '',
                    _created_at: 0,
                    _id:''
                },
                defaultItem: {
                    _description: '',
                    _code: '',
                    _created_at: 0,
                    _id:''
                },
                labelRules: [
                    v => !!v || this.$t('name_required'),
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                codeRules: [
                    v => !!v || this.$t('code_required'),
                ],
                descriptionRules: [
                    v => !!v || this.$t('description_required'),
                ],
                fileRules: [
                    v => !!v || this.$t('file_required'),
                ],
            }
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? this.$t('categoriemarchand.new_categorie') : this.$t('categoriemarchand.update_categorie')
            },
            ...mapState('newsletters/',['newsletters']),
            drop_down_categorie: function(){

                return [{text:"Tous les mails",value:-1},{text:"Envoyer",value:"envoyer"},{text:"Brouillons",value:"brouillon"},{text:"Dans Corbeille",value:'corbeille'}];
            },
        },
        mounted(){
            this.$store.dispatch('newsletters/filter','brouilon').then(response=>{
                console.log('Brouillon', response)
                this.brouillons=response.newsletters;
            });
        },
        watch: {
            dialog (val) {
                val || this.close()
            },
            dialog1 (val) {
                val || this.close1()
            },
            dialog2 (val) {
                val || this.close1()
            },
        },
        methods: {
            initialize () {
                this.langues = [
                    {
                        name:'Bénin',
                        code_iso_alpha_2:'BJ',
                        code_iso_alpha_3:'BEN',
                        code_iso_numerique:204
                    }
                ]
            },
            showdescription(vdes){
                if (vdes===undefined) {
                    this.desc = 'Vide';
                    this.dialog1 = true;
                }else{
                    this.desc = vdes;
                    this.dialog1 = true;
                }

            },
            userdetail(vdes){
                if (vdes===undefined) {
                    this.userdetails= 'Vide';
                    this.dialog2 = true;
                }else{
                    this.userdetails = vdes;
                    this.dialog2 = true;
                }

            },
            filterMarchands(criteria){

                if (criteria==="role")
                    this.$store.dispatch('users/filterUsersByRole', this.role_key).then(() => {});
                else
                    this.$store.dispatch('newsletters/filter', this.search_key).then(() => {});
            },
            editItem (item) {
                this.editedIndex = this.newsletters.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true;
                this.id = item._id;
            },
            deleteItem (item) {
                let VueBox=this;
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: this.$t('delete_warning'),
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    confirmButtonColor:'#29B3A6',
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.submitting = true;
                        this.$store.dispatch('newsletters/delete', item._id).then((result) => {
                            this.submitting = false ;
                            if (!result.error){
                                VueBox.toast('success',this.$t(result.message));

                            }
                        })
                    }
                })
            },
            corbeille (item) {
                let VueBox=this;

                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: 'Vous êtes sûr de vouloir deplacer cet élément dans la corbeille ?',
                    confirmButtonText: "Oui",
                    cancelButtonText: "Non",
                    confirmButtonColor:'#29B3A6',
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.submitting = true;
                        this.$store.dispatch('newsletters/corbeille', item._id).then((result) => {
                            this.submitting = false ;
                            if (!result.error){
                                VueBox.toast('success',this.$t(result.message));

                            }
                        })
                    }
                })
            },
            restitue (item) {
                let VueBox=this;

                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: 'Vous êtes sûr de vouloir deplacer cet élément dans la liste des envoies ?',
                    confirmButtonText: "Oui",
                    cancelButtonText: "Non",
                    confirmButtonColor:'#29B3A6',
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.submitting = true;
                        this.$store.dispatch('newsletters/restitue', item._id).then((result) => {
                            this.submitting = false ;
                            if (!result.error){
                                VueBox.toast('success',this.$t(result.message));

                            }
                        })
                    }
                })
            },
            description (item) {
                Swal.fire({
                    title: this.$t('description'),
                    timerProgressBar: false,
                    text: item._description,
                    confirmButtonText: "OK",
                    confirmButtonColor:'#29B3A6',
                })
            },

            close () {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            close1 () {
                this.dialog1 = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
            },
            close2 () {
                this.dialog2 = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                });
            },

            save () {
                this.customSnack.snackbar = false;
                this.mis=true;
                let VueBox = this;
                let data = new FormData();
                data.append("code",this.editedItem._code);
                data.append("description",this.editedItem._description);
                data.append("name",this.editedItem._name);
                if (this.id)
                    data.append("id",this.id);
                this.submitting = true;
                this.$store.dispatch('category_marchands/setCategorie_Marchand',data).then((response)=>{
                    console.log('set categorie response',response)
                    this.submitting = false;
                    if (response.error){
                        this.errors.operation=response.message;
                    }else{
                        VueBox.$parent.resetDatas(VueBox);
                        this.close();
                        if (!response.error){
                            VueBox.toast('success',this.$t(response.message));

                        }
                    }
                })
            },
            validate () {
                this.$refs.form.validate()
            },
            reset () {
                this.$refs.form.reset()
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },
            fileChange() {
                console.log( this.$refs);
                this.editedItem._file = this.$refs.file.files[0];
            },
            getFileOriginalName(file){
                return file.substr(file.lastIndexOf('/')+1)
            },
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        },
    }
</script>

<style scoped>

</style>